
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyPilarDanger as ObiBuoyPilarDangerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-pilar-danger.js';
 
 
 

 
 export const ObiBuoyPilarDanger = createComponent({
   react: React,
   tagName: 'obi-buoy-pilar-danger',
   elementClass: ObiBuoyPilarDangerElement,
   events: {
     
   }
  });
 
 